let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4Vsi2")).then(() => parcelRequire('2fssV'));